export const KPI_FILTER_CONFIGS = {
  MONITORED: JSON.stringify({
    field: 'monitoring',
    value:
      'monitored,managed,growing,shrinking,merging,migrating,detaching,snapshotting,modifying,unmigrating',
    op: 'in',
  }),
  AUTOSCALING_ON: JSON.stringify({
    field: 'autoscalingState',
    value: 'on',
    op: 'equals',
  }),
  SUPPORTED_OR_POTENTIAL: JSON.stringify({
    field: 'supported',
    value: 'true,potential',
    op: 'equals',
  }),
} as const;
